<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="counter_id" [ttModel]="edit.counter_id" ttReadonly></tt-input>
        <tt-input ttLabel="counter_keyno" [ttModel]="edit.counter_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="lastnumber" [(ttModel)]="edit.lastnumber" ttTextAlign="right" [ttButtons]="lastNumberButtons"></tt-input>
        <tt-input-number ttLabel="stepnumber" [(ttModel)]="edit.stepnumber" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-input-number ttLabel="grabnumber" [(ttModel)]="edit.grabnumber" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-button-save ttText="counter_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
